import CardInfo from './CardInfo'

const Apply = () => {
  return (
    <>
      <CardInfo
        text={
          <>
            Deve ser enviadas as fichas com os seguintes modelos no inbox da
            base:
            <br />
            <br />
            ON:
            <br />
            <br />
            — Nome completo: minúsculo /@user
            <br />
            — Data de nascimento: 00/00/0000 (2004-2002)
            <br />
            — Pronomes: minúsculo
            <br />
            — Sexualidade: minúsculo
            <br />
            — Shape: minúsculo
            <br />
            <br />
            OFF:
            <br />
            <br />
            — Nome: minúsculo
            <br />
            — Pronomes: minúsculo
            <br />
            — Idade: (não será postado)
            <br />
            <br />
            Serão aceitos até três shapes por pensonagem; No caso de um, mandar
            duas fotos dele, no caso de mais, mandar uma foto de cada um.
          </>
        }
      />
    </>
  )
}

export default Apply
